import { AppHostErrorControl, AppHostLoadingControl, } from '@office-start/app-host-ui-controls';
import React from 'react';
var AppHostHubUiService = /** @class */ (function () {
    function AppHostHubUiService(correlationId, refreshCallBack, locStrings, telemetry, appId) {
        var _this = this;
        this.getLoadingUi = function () {
            _this.scenario.stop();
            return React.createElement(AppHostLoadingControl, { label: _this.locStrings.loadingLabel });
        };
        this.getErrorUi = function (reason) {
            _this.scenario.fail("App failure reason: ".concat(reason));
            return (React.createElement(AppHostErrorControl, { correlationId: _this.correlationId, refreshCallBack: _this.refreshCallBack, errorStrings: {
                    errorUiHeaderText: _this.locStrings.errorUiTitle,
                    errorUiSecondaryText: _this.locStrings.errorUiLabel,
                    correlationIdLabel: _this.locStrings.correlationId,
                    retryButtonText: _this.locStrings.retryButtonTitle,
                } }));
        };
        this.correlationId = correlationId;
        this.refreshCallBack = refreshCallBack;
        this.locStrings = locStrings;
        this.telemetry = telemetry;
        this.appId = appId;
        this.scenario = this.telemetry.createScenario('appInitialization', this.appId);
    }
    return AppHostHubUiService;
}());
export { AppHostHubUiService };
//# sourceMappingURL=AppHostHubUiService.js.map